import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../AssetHelpers";
type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
  color?: string;
};

const KTSVG: React.FC<Props> = ({ className = "", path, svgClassName = "mh-50px", color = "white" }) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG
        src={toAbsoluteUrl(path)}
        className={svgClassName}
        preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${color}"`)}
      />
    </span>
  );
};

export { KTSVG };
